import React, { useEffect, useMemo, useState } from "react";
import { RCCAlert, RCCHookToast, RCCServicesApi } from "react-common-components";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import returnColor from "src/utils/returnColor";
import { IAssociations, IKanban, IKanbanContent } from "../interface";
import BadgeKanbanType from "./badgeKanbanType";
import ColumnsKanban from "./columnsKanban";
import FiltersAssociationsKanban from "./filtersAssociationsKanban";

const KanbanContent: React.FC<IKanbanContent> = ({
	columns,
	containers,
	findContainer,
	waitingForResponse,
	items,
	onRemoveColumn,
	handleAddColumn,
	activeId,
	selectedKanban,
	typeKanban,
	setcolumns,
	modalCancelRef,
	modalCommentsRef,
	modalEfficiencyRef,
	modalHistoryRef,
	modalPostponementRef,
	modalProgressRef,
	modalAddChangeDelete,
	modalsSubactionsRef,
	modalShowPostponementsRef,
	callbackUpdateAction,
	ITEMS_WITH_NO_CONTAINER,
	PLACEHOLDER_ID,
	associations,
	errorAssociation,
	queryColumnsKanban
}) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();

	const [associationsInternal, setAssociationsInternal] = useState<IAssociations | undefined>(associations);
	const [selectedKanbanInternal, setSelectedKanbanInternal] = useState<IKanban | undefined>(undefined);
	
	const queryUpdateColumn = async(kba002Id: number, kba002Descricao: string, kba002Cor: string) => {
		try{
			await RCCServicesApi.postRequest({
				method: "Kanban/UpdateColumn",
				body: {
					kba002Id,
					kba002Descricao,
					kba002Cor: returnColor(kba002Cor).replace("#", "")
				}
			});
			return true;
		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar coluna"), addToast);
			return false;
		}
	};

	const onChangeColorColumn = async (containerKey: string, newColor: string) => {
		const res = await queryUpdateColumn(columns[containerKey].kba002Id,columns[containerKey].kba002Descricao, newColor);
		if(!res)
			return;
		setcolumns((columnsX) => ({
			...columnsX,
			[containerKey]: {
				kba002Id: columnsX[containerKey].kba002Id,
				kba002Cor: newColor,
				kba002Descricao: columnsX[containerKey].kba002Descricao,
				kba002Ordem: 0
			}
		}));
	};
	
	const onChangeTitleColumn = async (containerKey: string, newTitle: string) => {
		const res = await queryUpdateColumn(columns[containerKey].kba002Id,newTitle, columns[containerKey].kba002Cor);
		if(!res)
			return;
		setcolumns((columnsX) => ({
			...columnsX,
			[containerKey]: {
				kba002Id: columns[containerKey].kba002Id,
				kba002Cor: columnsX[containerKey].kba002Cor,
				kba002Descricao: newTitle,
				kba002Ordem: 0
			}
		}));
	};

	const ColumnsKanbanMemo = useMemo(() => (
		<>
			<ColumnsKanban 
				columns={columns}
				containers={containers}
				findContainer={findContainer}
				disabled={waitingForResponse}
				items={items}
				newItemsContainerName={ITEMS_WITH_NO_CONTAINER}
				onChangeColorColumn={onChangeColorColumn}
				onChangeTitleColumn={onChangeTitleColumn}
				onRemoveColumn={onRemoveColumn}
				handleAddColumn={handleAddColumn}
				activeId={activeId}
				selectedKanban={selectedKanban}
				placeholderId={PLACEHOLDER_ID}
				modalCancelRef={modalCancelRef}
				modalCommentsRef={modalCommentsRef}
				modalEfficiencyRef={modalEfficiencyRef}
				modalHistoryRef={modalHistoryRef}
				modalPostponementRef={modalPostponementRef}
				modalProgressRef={modalProgressRef}
				modalsRef={modalAddChangeDelete}
				modalsSubactionsRef={modalsSubactionsRef}
				modalShowPostponementsRef={modalShowPostponementsRef}
				onCallbackUpdateFunction={callbackUpdateAction}
				typeKanban={typeKanban}
			/>
		</>
	), [columns, containers, activeId, items, waitingForResponse]);

	const queryColumns = (associationsX: IAssociations | undefined) => {
		setAssociationsInternal(associationsX);
		queryColumnsKanban(selectedKanban, associationsX);
	};

	useEffect(() => {
		if(!selectedKanbanInternal || selectedKanbanInternal.kba001Id !== selectedKanban.kba001Id){
			setAssociationsInternal(undefined);
			setSelectedKanbanInternal(selectedKanban);
		}	
	}, [selectedKanban]);

	useEffect(() => {
		setAssociationsInternal(associations);
	}, [associations]);


	return (
		<>
			<Title color="purple" size="xl">
				{selectedKanban.kba001Descricao} 
				<BadgeKanbanType 
					styleInline="margin-left: 10px;"
					type={selectedKanban.kba001Tipo}
				/>
			</Title>
		
			<FiltersAssociationsKanban 
				typeKanban={typeKanban}
				associations={associationsInternal}
				selectedKanban={selectedKanban}
				queryColumns={queryColumns}	
			/>

			{!errorAssociation ? (
				<>
					{ColumnsKanbanMemo}
				</>
			): (	
				<RCCAlert
					description={translate("Por favor, preencha os campos obrigatórios acima")}
				/>
			)}
		</>
	);
};

export default KanbanContent;
